import React from "react";

const AlertIcon = ({fill}: {fill?: string}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_26587_137340)">
      <g clipPath="url(#clip1_26587_137340)">
        <path
          fill={fill || "#E0E0E0"}
          d="M7.9987 1.33203C4.3187 1.33203 1.33203 4.3187 1.33203 7.9987C1.33203 11.6787 4.3187 14.6654 7.9987 14.6654C11.6787 14.6654 14.6654 11.6787 14.6654 7.9987C14.6654 4.3187 11.6787 1.33203 7.9987 1.33203ZM8.66536 11.332H7.33203V9.9987H8.66536V11.332ZM8.66536 8.66536H7.33203V4.66536H8.66536V8.66536Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_26587_137340">
        <rect width="16" height="16" fill="white" />
      </clipPath>
      <clipPath id="clip1_26587_137340">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default AlertIcon;
